import React from "react";

const ProductDimensionView = ({ watch }) => {
  return (
    <div className="card-footer" style={{ borderRadius: 10 }}>
      <div className="row">
        <div className="col-md-12">
          <h6>Product Dimension</h6>
          <div className="dropdown-divider" />
          <div className="row">
            <div className="col-md-2">
              <div className="text-secondary">Height (mm)</div>
              <p>{watch("height")}</p>
            </div>
            <div className="col-md-2">
              <div className="text-secondary">Width (mm)</div>
              <p>{watch("width")}</p>
            </div>
            <div className="col-md-2">
              <div className="text-secondary">Length (mm)</div>
              <p>{watch("length")}</p>
            </div>
            <div className="col-md-2">
              <div className="text-secondary">Depth (mm)</div>
              <p>{watch("depth")}</p>
            </div>
            <div className="col-md-2">
              <div className="text-secondary">Volume (kgv)</div>
              <p>{watch("volume")}</p>
            </div>
          </div>

          <div className="row mt-2">
            <div className="col-md-2">
              <div className="text-secondary">Thickness (mm)</div>
              <p>{watch("thickness")}</p>
            </div>
            <div className="col-md-2">
              <div className="text-secondary">Weight (kg)</div>
              <p>{watch("weight")}</p>
            </div>
            <div className="col-md-2">
              <div className="text-secondary">Weight Unit</div>
              <p>{watch("weight_type")}</p>
            </div>
          </div>
        </div>

        <div className="col-md-12 mt-3">
          <h6>Package Dimension</h6>
          <div className="dropdown-divider" />
          <div className="row">
            <div className="col-md-2">
              <div className="text-secondary">Outer Height (mm)</div>
              <p>{watch("outer_height")}</p>
            </div>
            <div className="col-md-2">
              <div className="text-secondary">Outer Width (mm)</div>
              <p>{watch("outer_width")}</p>
            </div>
            <div className="col-md-2">
              <div className="text-secondary">Outer Length (mm)</div>
              <p>{watch("outer_length")}</p>
            </div>
            <div className="col-md-2">
              <div className="text-secondary">Outer Depth (mm)</div>
              <p>{watch("outer_depth")}</p>
            </div>
            <div className="col-md-2">
              <div className="text-secondary">Outer Weight (kg)</div>
              <p>{watch("outer_weight")}</p>
            </div>
          </div>
        </div>

        <div className="col-md-12 mt-3">
          <h6>Cut Out Dimension</h6>
          <div className="dropdown-divider" />
          <div className="row">
            <div className="col-md-2">
              <div className="text-secondary">Height (mm)</div>
              <p>{watch("cut_out_height")}</p>
            </div>
            <div className="col-md-2">
              <div className="text-secondary">Width (mm)</div>
              <p>{watch("cut_out_width")}</p>
            </div>
            <div className="col-md-2">
              <div className="text-secondary">Length (mm)</div>
              <p>{watch("cut_out_length")}</p>
            </div>
            <div className="col-md-2">
              <div className="text-secondary">Depth (mm)</div>
              <p>{watch("cut_out_depth")}</p>
            </div>
          </div>
        </div>

        <div className="col-md-12 mt-3">
          <h6>Topmount Cut Out Dimension</h6>
          <div className="dropdown-divider" />
          <div className="row">
            <div className="col-md-2">
              <div className="text-secondary">Height (mm)</div>
              <p>{watch("cut_out_height_topmount")}</p>
            </div>
            <div className="col-md-2">
              <div className="text-secondary">Width (mm)</div>
              <p>{watch("cut_out_width_topmount")}</p>
            </div>
            <div className="col-md-2">
              <div className="text-secondary">Length (mm)</div>
              <p>{watch("cut_out_length_topmount")}</p>
            </div>
          </div>
        </div>

        <div className="col-md-12 mt-3">
          <h6>Undermount Cut Out Dimension</h6>
          <div className="dropdown-divider" />
          <div className="row">
            <div className="col-md-2">
              <div className="text-secondary">Height (mm)</div>
              <p>{watch("cut_out_height_undermount")}</p>
            </div>
            <div className="col-md-2">
              <div className="text-secondary">Width (mm)</div>
              <p>{watch("cut_out_width_undermount")}</p>
            </div>
            <div className="col-md-2">
              <div className="text-secondary">Length (mm)</div>
              <p>{watch("cut_out_length_undermount")}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDimensionView;
